import React, { useEffect, useState } from "react";
import { AlertTriangle, Clock, CheckCircle2 } from "lucide-react";
import { LEVEL_SLA_MINUTES, LEVEL_LABELS } from "@/lib/constants";

export default function SLABadge({ createdAt, levelStartedAt, currentLevel = "ps", status, escalated }) {
  const [remainingMs, setRemainingMs] = useState(null);

  useEffect(() => {
    const compute = () => {
      const anchor = levelStartedAt || createdAt;
      const minutes = LEVEL_SLA_MINUTES[currentLevel] ?? 30;
      const started = new Date(anchor).getTime();
      const deadline = started + minutes * 60 * 1000;
      setRemainingMs(deadline - Date.now());
    };
    compute();
    const id = setInterval(compute, 15000);
    return () => clearInterval(id);
  }, [createdAt, levelStartedAt, currentLevel]);

  if (status === "resolved") {
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-emerald-50 text-emerald-800 border border-emerald-200 text-xs font-medium" data-testid="sla-resolved">
        <CheckCircle2 className="w-3.5 h-3.5" /> Resolved
      </span>
    );
  }
  if (remainingMs == null) return null;
  const isBreach = remainingMs <= 0;
  const abs = Math.abs(remainingMs);
  const hours = Math.floor(abs / (60 * 60 * 1000));
  const minutes = Math.floor((abs % (60 * 60 * 1000)) / (60 * 1000));
  const levelLabel = LEVEL_LABELS[currentLevel] || currentLevel;

  if (isBreach) {
    const overStr = hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-red-50 text-red-800 border border-red-300 text-xs font-medium sla-pulse" data-testid="sla-breach">
        <AlertTriangle className="w-3.5 h-3.5" /> {levelLabel} SLA breached · {overStr} over
      </span>
    );
  }
  const warn = remainingMs < 10 * 60 * 1000;
  const leftStr = hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium border ${
        warn ? "bg-amber-50 text-amber-900 border-amber-300" : "bg-slate-50 text-slate-800 border-slate-200"
      } ${escalated ? "ring-1 ring-red-300" : ""}`}
      data-testid="sla-active"
    >
      <Clock className="w-3.5 h-3.5" /> {levelLabel} · {leftStr} left
    </span>
  );
}
